import React, { useEffect, useState } from 'react';
import ReportIndex from './components/reportIndex';
import ReportPage from './components/reportPage';
import PlanPage from './components/planPage';
import ClassPage from './components/classPage';

const ReportBox = (props) => {
  //  page = 0 首页 page = 1 查看体测报告  page = 2查看训练计划
  //  page = 3 约课页 page = 4 编辑教练，上课页
  const switchPage = (page) => {
    switch (page) {
      case 0:
        return <ReportIndex {...props} />;
      case 1:
        return <ReportPage {...props} />;
      case 2:
        return <PlanPage {...props} />;
      case 3:
        return <ClassPage {...props} />;
    }
  };

  return switchPage(props.report.page);
};

export default ReportBox;
